import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PatientDataTable from "./PatientDataTable";
import PrimaryHeader from "../../../common/primaryHeader/PrimaryHeader";
import { Helmet } from "react-helmet";
import { capitalize } from "lodash";
import InvitedPatientTable from "./InvitedPatients";

const AllPatients = (props) => {
  const {
    loading,
    patientData,
    newPatient,
    bhiPatient,
    invitedPatient,
    inActivePatient,
  } = useSelector((state) => state.patient);
  const [data, setData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentUrl, setCurrentUrl] = useState("");
  const [status, setStatus] = useState(null);
  const [flag, setFlag] = useState(null);

  useEffect(() => {
    const tempCurrentUrl = window.location.pathname
      .split("/patients/")[1]
      .replace("/", "");
    const tempStatus = searchParams.get("status");
    if (tempCurrentUrl === "bhi" && tempStatus !== null) {
      setStatus(tempStatus);
    }
    setFlag(searchParams.get("flag"));
    setCurrentUrl(tempCurrentUrl);
  }, [searchParams]);

  const handleBifurcation = () => {
    const handleFiltering = (data, bhi = false) => {
      let filteredData = JSON.parse(JSON.stringify(data));
      if (flag) {
        filteredData = filteredData.filter((item) => {
          let temp = item.flag || "";
          if (temp.toLowerCase() === flag) {
            return item;
          }
        });
      }

      if (bhi) {
        filteredData = filteredData.filter((item) => {
          const bhiEligible = JSON.parse(item?.bhi_eligible);
          const bhiEnrolled = JSON.parse(item?.bhi_enabled);
          if (bhiEligible && !bhiEnrolled) {
            return item;
          }
        });
      }

      return filteredData;
    };

    if (currentUrl === "all") {
      if (flag) {
        const temp = handleFiltering(patientData);
        setData(temp);
      } else {
        setData(patientData);
      }
    } else if (currentUrl === "new") {
      if (flag) {
        const temp = handleFiltering(newPatient);
        setData(temp);
      } else {
        setData(newPatient);
      }
    } else if (currentUrl === "bhi") {
      if (flag) {
        const temp = handleFiltering(bhiPatient);
        setData(temp);
      } else {
        if (status === "eligible") {
          const temp = handleFiltering(patientData, true);
          setData(temp);
        } else {
          setData(bhiPatient);
        }
      }
    } else if (currentUrl === "inactive") {
      if (flag) {
        const temp = handleFiltering(inActivePatient);
        setData(temp);
      } else {
        setData(inActivePatient);
      }
    } else if (currentUrl === "invited") {
      if (flag) {
        const temp = handleFiltering(invitedPatient);
        setData(temp);
      } else {
        setData(invitedPatient);
      }
    }
  };

  useEffect(() => {
    if (loading) return;
    handleBifurcation();
  }, [currentUrl, status, loading]);

  useEffect(() => {
    handleBifurcation();
  }, [patientData, newPatient, bhiPatient, invitedPatient, inActivePatient]);

  return (
    <section className="container-fluid p-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {`${currentUrl !== "bhi" ? capitalize(currentUrl) : "BHI"} Patients`}{" "}
          | Precise Digital
        </title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <PrimaryHeader
        titleText={`${
          currentUrl !== "bhi" ? capitalize(currentUrl) : "BHI"
        } Patients`}
        showSubtitle={false}
        showPill
        pillText={`${data?.length} Patient${data?.length > 1 ? "s" : ""}`}
      />
      {currentUrl === "invited" ? (
        <InvitedPatientTable currentUrl={currentUrl} flag={flag} />
      ) : (
        <PatientDataTable currentUrl={currentUrl} flag={flag} />
      )}
    </section>
  );
};

export default AllPatients;
